import AppSubMenu from './AppSubMenu'
import type { MenuModel } from '../../types/types'
import { useContext, useEffect, useState } from 'react'
import { RdmsMenuContext } from '../menu/context/rdmsMenuContext'
import { Menu } from '../../types/menu'
import {useTranslation} from "react-i18next";

const AppMenu = () => {
    const { menus } = useContext(RdmsMenuContext)
    const { t, i18n } = useTranslation();
    const [models, setModels] = useState<MenuModel[]>([])
    let language = i18n.resolvedLanguage;

    useEffect(() => {
        const toMenuModel = (items: Menu[] = []): MenuModel[] => {
            if (!items || items.length === 0) return [];

            return items.map((item) => ({
                label: language === 'ja' ? item.japanLabel : item.label,
                to: item.to,
                icon: item.icon,
                url: item.url || '',
                menuTypeCd: item.menuTypeCd,
                items: item.to || item.url ? undefined : toMenuModel(item.items),
            }));
        };

        // 새로 생성된 sideMenus를 models에 한 번에 설정
        const sideMenus: MenuModel[] = menus.map((titleMenu) => ({
            label: language === 'ja' ? titleMenu.japanLabel : titleMenu.label,
            icon: titleMenu.icon,
            menuTypeCd: titleMenu.menuTypeCd,
            items: toMenuModel(titleMenu.items),
        }));

        setModels(sideMenus); // 중첩 방지를 위해 한 번만 상태 설정
    }, [menus, language]);

    return <AppSubMenu model={models} />
}

export default AppMenu
